import { render, staticRenderFns } from "./ReviewDetails.vue?vue&type=template&id=46cd52b9&scoped=true"
import script from "./ReviewDetails.vue?vue&type=script&lang=js"
export * from "./ReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./ReviewDetails.vue?vue&type=style&index=0&id=46cd52b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cd52b9",
  null
  
)

export default component.exports